import React from 'react';

export type NestedMessageProps = {
  message: Object | string;
  level?: 'danger' | 'warning' | 'info';
  className?: string;
};

export const NestedMessage: React.FC<NestedMessageProps> = ({
  message,
  level,
  className,
}) => {
  if (message && typeof message === 'object') {
    return (
      <div className={className}>
        {Object.entries(message).map(([key, value]) => (
          <span key={key}>
            {!Array.isArray(message) && (
              <span className={`text-${level}`}>{key}:</span>
            )}
            <NestedMessage className="px-2" message={value} level={level} />
          </span>
        ))}
      </div>
    );
  } else if (typeof message === 'string') {
    return <span className={`text-${level} ${className}`}>{message}</span>;
  }
  return null;
};
